import React from 'react'
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Grid, Container, Button } from '@material-ui/core';
import RabbitImg from '../../../../images/leaping-rabbit.png'
import useMediaQuery from "@material-ui/core/useMediaQuery"

const useStyles = makeStyles((theme) => ({
    heroWrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(90deg, #232d52 0%, rgba(38,49,89,1) 100%)',
        alignItems: 'center'
    },
    heroWrapperContent: {
        flexGrow: 1,
        display: 'flex',
        zIndex: 6,
        width: '100%',
        alignItems: 'center'
    },
    bgWrapperContent: {
        position: 'relative',
        zIndex: 7,
        width: '100%'
    },
    topPadding: {
        paddingTop: 160,
        [theme.breakpoints.only('xs')]: {
            paddingTop: 120,
        },
    },
    noPadding: {
        paddingBottom: 0
    },
    textContainer: {
        color: '#ffffff',
        paddingBottom: '8rem',
        width: '100%',
    },
    bottomPadding: {
        paddingBottom: '3rem'
    },
    textGrid: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.only('xs')]: {
            position: 'relative'
        },
    },
    textAlign: {
        textAlign: 'left'
    },
    title: {
        fontSize: '4rem',
        [theme.breakpoints.only('xs')]: {
            fontSize: '3.5rem',
        },
        lineHeight: 1.05,
        fontFamily: '\'Stupid Meeting\', sans-serif',
        marginBottom: 10,
        hyphens: 'none',
        position: 'relative'
    },
    prisonBreakSpan:{
        fontSize: '6rem',
        [theme.breakpoints.only('xs')]: {
            fontSize: '5rem',
        },
        hyphens: 'none'
    },
    yellowSpan: {
        color: '#FFDE43'
    },
    subtitle: {
        paddingBottom: '1rem',
        fontSize: '1.265rem',
        [theme.breakpoints.only('xs')]: {
            fontSize: '1rem',
        },
        marginTop: 0,
        marginBottom: '1rem',
        color: 'rgba(255, 255, 255, 1)',
        hyphens: 'none',
        lineHeight: '1.75rem'
    },
    byline: {
        fontSize: '1rem',
        color: 'rgba(255, 255, 255, 0.5)',
        marginBottom: 10
    },
    rabbitGridItem: {
        position: 'relative',
        minHeight: 200,
    },
    rabbit: {
        maxHeight: 600,
        position: 'absolute',
        //zIndex: 1,
        bottom: -150,
        right: 0,
        [theme.breakpoints.only('md')]: {
            opacity: 0.3,
            zIndex: -1
        },
    },
    mobileRabbit: {
        maxHeight: 300,
        position: 'absolute',
        zIndex: -1,
        bottom: 0,
        right: -40,
        opacity: 0.2

    },
    mark: {
        padding: '1px 7px 3px 7px',
        [theme.breakpoints.only('xs')]: {
            padding: '0px 7px 1px 7px',
        },
        backgroundColor: 'rgb(0,0,0,0.3)',
        borderRadius: 100,
        fontWeight: 'bold',
        border: '1px solid #FFDE43',
        color: '#FFDE43'
    }
}));

const IndexHeader = () => {
    const classes = useStyles()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    return(
        <>
            <div className={classes.heroWrapper}>
                <div className={classes.heroWrapperContent}>
                    <div className={classes.bgWrapperContent}>
                        <div className={classes.topPadding}>
                            <div className={classes.noPadding}>
                                <Container className={classes.textContainer}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12} lg={6} className={classes.textGrid}>
                                            <div className={classes.textAlign}>
                                                <p className={classes.byline}>
                                                    ⭐⭐⭐⭐⭐ { isMobile && <br/>}"THE BIGGEST MINDF*CK OF MY LIFE"
                                                </p>
                                                <h2 className={classes.title}>
                                                    The Great <span className={classes.yellowSpan}>Existential</span><br/> <span className={classes.prisonBreakSpan}>Prison Break</span>
                                                    {isMobile && <img src={RabbitImg} className={classes.mobileRabbit}/>}
                                                </h2>
                                                <p className={classes.subtitle}>
                                                    Come with me. We'll follow a trail of <mark className={classes.mark}>deductive&nbsp;logic</mark>, and break out of <mark className={classes.mark}>The&nbsp;Simulation</mark> together...
                                                </p>
                                            </div>
                                        </Grid>
                                        {!isMobile &&
                                        <Grid item xs={12} lg={6} className={classes.rabbitGridItem}>
                                            <img src={RabbitImg} className={classes.rabbit}/>
                                        </Grid>
                                        }

                                    </Grid>
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IndexHeader
